import { createApp } from 'vue/dist/vue.esm-bundler.js'
{
  const appConfig = {
    data(){
      return {
        // localized data
        nominees: [], 

        // user data:
        search: '',
        sortOrder: 'random',
        filterCategory: null,
      }
    },
    mounted(){
      this.nominees = window?.availableNominees || []
      this.loading = false
    },
    computed: {
      filteredNominees(){
        let filteredNoms = this.nominees.filter(n => {
          let searchValid = true
          let categoryValid = true

          if(this.search){
            const search = this.search.toLowerCase().trim()
            const firstName = n.first_name.toLowerCase().trim()
            const lastName = n.last_name.toLowerCase().trim()
            const memberName = n.member_name.toLowerCase().trim()
            searchValid = `${firstName} ${lastName}`.indexOf(search) != -1 || memberName.indexOf(search) != -1
          }

          if(this.filterCategory){
            categoryValid = n.event_category == this.filterCategory 
          }

          return searchValid && categoryValid
        })

        return filteredNoms.sort((a,b) => {
          if(this.sortOrder == "asc"){
            return a.first_name > b.first_name ? 1 : -1
          } else if(this.sortOrder == "desc"){
            return a.first_name > b.first_name ? -1 : 1
          } else {
            return a.rand_int > b.rand_int ? -1 : 1
          }
        })
      }
    }
  }

  function initApp(){
    const els = document.querySelectorAll('.rose-awards-vote-listing')
    if(els.length){
      els.forEach(el => {
        const app = createApp(appConfig)
        app.mount(el)
      })
    }
  }

  initApp()
}